import { CardContent, Grid2 as Grid, Typography, Card } from "@mui/material"
import React from "react"
import { RightioWBSAPIModelsSPSpBookingGetLastJobResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from "@utils/apis/wbs/endpoints"

const name = "CustomerCard"

type CustomerCardProps = {
    parent: string
    job?: RightioWBSAPIModelsSPSpBookingGetLastJobResult
    jobDetails: RightioWBSAPIModelsSPSpJobsGetJobDetailsResult | undefined
}

const CustomerCard: React.FC<CustomerCardProps> = ({ parent, job, jobDetails }) => (
    <Card sx={{ mb: 1 }}>
        <CardContent>
            {jobDetails?.customerTitle &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Customer Title:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.customerTitle}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.customerForename &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >First Name:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.customerForename}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.customerSurname &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Last Name:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.customerSurname}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.telephoneMobile &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Mobile:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.telephoneMobile}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.telephoneLandline &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Landline:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.telephoneLandline}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.emailAddress &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >E-mail Address:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.emailAddress}</span></Typography>
                    </Grid>
                </Grid>}
            {jobDetails?.postcode &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Postcode:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1" ><span style={{ color: "blue" }}>{jobDetails?.postcode}</span></Typography>
                    </Grid>
                </Grid>}
            {(jobDetails?.isLandlord || jobDetails?.isTenant || jobDetails?.isPropertyOwner) &&
                <Grid container>
                    <Grid size={6}>
                        <Typography sx={{ textAlign: "right", pr: 2 }} variant="body1" >Customer Type:</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1"><span style={{ color: "blue" }}>{jobDetails?.isLandlord ? "Landlord" : jobDetails?.isTenant ? "Tenant" : "Home Owner"}</span></Typography>
                    </Grid>
                </Grid>}
        </CardContent>
    </Card>
)

CustomerCard.displayName = name

export default React.memo(CustomerCard)

